import gql from "graphql-tag";
import { useQuery } from "@apollo/client";
import { apolloClient } from "../apolloClient";

export default (handle) => {
  const { data, loading } = useQuery(GET_ARTICLE, { variables: { handle } });

  const article = data?.article;

  return { article, loading };
};

const loader = async (handle) => {
  const query = {};
  if (handle !== "/") query.handle = handle;
  else query.homepage = true;

  return apolloClient.query({ query: GET_ARTICLE, variables: query });
};

export { loader };

const ARTICLE_FIELDS = `
  _id
  id
  seo {
    index
    description
  }
  published {
    date
  }
  content {
    rows {
      id
      layout
      options {
        fullWidth
        carousel
        backgroundColor
        noPadding
      }
      columns {
        id
        blocks {
          type
          id
          data
        }
      }
    }
  }
  thumbnail {
    title
    formatArray {
      name
      url
      width
      height
    }
  }
  homepage
  title
  tags
  handle
`;

export const GET_ARTICLE = gql(`
  query($homepage: Boolean, $id: Int, $handle: String $preview: Boolean) {
    article(homepage: $homepage, id: $id, handle: $handle preview: $preview) {
      ${ARTICLE_FIELDS}
    }
}`);
